import { Box, TextButton } from '@wix/design-system';
import React, { useContext, useState, useMemo } from 'react';
import { HTML_TYPE } from 'ricos-content';
import { EditorContext, RicosContext } from 'ricos-context';
import { HTMLData_Source } from 'ricos-schema';
import { FloatingLayout, FooterActions } from 'wix-rich-content-ui-components';
import { EDIT_PANEL, EDIT_PANEL_CANCEL_BUTTON, EDIT_PANEL_UPDATE_BUTTON } from '../../dataHooks.js';
import { AdsenseSourceInput } from './AdsenseSourceInput.js';
import { HtmlSourceInput } from './HtmlSourceInput.js';
import './HtmlInputArea.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const InsertModal = ({ nodeId, closeModal }) => {
  var _a;
  const { getEditorCommands } = useContext(EditorContext);
  const { isMobile } = useContext(RicosContext);
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const inputRef = React.useRef(null);
  const componentData = getEditorCommands().getBlockComponentData(nodeId);
  const initialComponentData = useMemo(() => componentData, []);
  const isAdsense = (_a = componentData == null ? void 0 : componentData.isAdsense) != null ? _a : componentData.source === HTMLData_Source.ADSENSE;
  const updateComponentData = (data) => {
    getEditorCommands().setBlock(nodeId, HTML_TYPE, __spreadProps(__spreadValues({}, data), {
      id: nodeId
    }));
  };
  const handleOnCancel = () => {
    updateComponentData(initialComponentData);
    closeModal();
  };
  const HtmlComponent = isAdsense ? AdsenseSourceInput : HtmlSourceInput;
  const Footer = isMobile ? FooterActions : FooterActionsDesktop;
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: handleOnCancel,
      dataHook: EDIT_PANEL,
      header: isMobile ? { title: "Edit HTML" } : void 0,
      content: {
        noPadding: true,
        children: /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP2", margin: "18px 18px 3px 18px" }, /* @__PURE__ */ React.createElement(
          HtmlComponent,
          {
            componentData,
            updateComponentData,
            setSubmittedInvalidUrl,
            submittedInvalidUrl,
            inputRef
          }
        ))
      },
      footer: {
        showDivider: isMobile,
        children: /* @__PURE__ */ React.createElement(
          Footer,
          {
            onCancel: handleOnCancel,
            onSave: () => {
              var _a2;
              if (submittedInvalidUrl) {
                (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
                return;
              }
              closeModal();
            }
          }
        )
      }
    }
  );
};
const FooterActionsDesktop = ({
  onCancel,
  onSave
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { align: "space-between" }, /* @__PURE__ */ React.createElement(
    TextButton,
    {
      underline: "always",
      size: "small",
      dataHook: EDIT_PANEL_CANCEL_BUTTON,
      onClick: onCancel
    },
    t("HtmlEditPanel_Cancel")
  ), /* @__PURE__ */ React.createElement(
    TextButton,
    {
      underline: "always",
      size: "small",
      dataHook: EDIT_PANEL_UPDATE_BUTTON,
      onClick: onSave
    },
    t("HtmlEditPanel_Update")
  ));
};

export { InsertModal };
//# sourceMappingURL=InsertModal.js.map
